import React, { useState, useEffect } from "react";
import { useDarkMode } from "../../components/DarkModeContext";
import { SunMoon } from "lucide-react";

const NavbarGenerale = () => {
    const { darkMode, toggleDarkMode, loadCorrectTheme } = useDarkMode();

    useEffect(() => {
        loadCorrectTheme(true, null);
    }, []);

    return (
        <nav className="grid grid-cols-3 bg-gray-200 dark:bg-neutral-800 p-1 items-center">
            <img src={darkMode ? "/img/LogoLight.png" : "/img/LogoDark.png"} className="h-12" />
            <div className="flex justify-center">
            </div>
            <div
                className="flex justify-end items-center pr-2 text-xs"
            >
                <span className="flex items-center hover:cursor-pointer" onClick={() => toggleDarkMode(false, null)}>
                    <SunMoon size={18} className="mr-1 text-blue-600 dark:text-blue-500" />
                    Cambia tema
                </span>
            </div>
        </nav>
    );
}
export default NavbarGenerale;